const workExperience = [
  {
    date: "Sept 2021 – Present",
    year: "2021-Present",
    company: "Veriday",
    role: "Senior Software Engineer",
    project: "Liferay DXP & AWS Infrastructure",
    responsibilities: [
      "• Led end-to-end development of enterprise Liferay DXP platforms for fintech and banking clients, including CIBC Innovation Banking, CIBC Private Wealth, Canadian Tire, and Laurentian Bank, delivering scalable, secure, and accessible portals.",
      "• Designed and implemented custom workflows, dashboards, and portlets using Service Builder, React, and Node.js, ensuring WCAG 2.1/2.2 and AODA compliance.",
      "• Owned AWS infrastructure (EC2, S3, RDS, DynamoDB, VPC, IAM) with CI/CD pipelines, Docker, and Kubernetes, optimizing performance, availability, and disaster recovery.",
      "• Integrated complex APIs and third-party systems (OAuth, payment gateways, enterprise tools) to extend platform functionality and streamline business workflows.",
      "• Optimized platform performance via query tuning, caching strategies, and Elasticsearch integration, improving user experience and response times.",
      "• Mentored developers and collaborated with cross-functional teams, providing technical guidance, best practices, and documentation to ensure maintainable, high-quality solutions.",
      "• Managed platform upgrades and migrations, reducing downtime and ensuring smooth transitions while maintaining compatibility with custom features.",
      "• Automated deployment processes using AWS CodePipeline, CodeBuild, and CodeDeploy, reducing manual intervention and improving CI/CD efficiency.",
      "• Ensured high availability and fault tolerance via CloudWatch monitoring, Auto Scaling, and RDS snapshots for disaster recovery.",
      "• Developed and maintained technical documentation in Confluence, enabling seamless knowledge transfer and client training.",
      "• Utilized Jira for sprint planning, task management, and progress tracking; Bitbucket for version control and branching strategies."
    ],
    technologies: [
      "Liferay DXP", "Java", "Spring Boot", "React.js", "Angular", "Node.js", "Elasticsearch",
      "REST APIs", "SQL", "Jenkins", "Docker", "Kubernetes",
      "AWS (EC2, RDS, S3, DynamoDB, VPC, IAM, CloudFormation, CloudWatch, Auto Scaling)",
      "Git", "Bitbucket", "Jira", "Confluence"
    ],
    clients: [
      "CIBC Innovation Banking", "CIBC Private Wealth Management", "Canadian Tire", "Laurentian Bank",
      "Kearney", "Saskatchewan Insurance Company", "IPCC", "Britannia School House", "Entando", "Freeman"
    ]
  },
  {
    date: "May 2020 – Jul 2023",
    year: "2020-2023",
    company: "Springboard",
    role: "Software Engineering Career Mentor",
    responsibilities: [
      "• Provided personalized 1:1 mentorship to individuals transitioning into the web development industry, fostering their growth and confidence in software engineering.",
      "• Addressed subject matter queries, offered constructive feedback, and supported mentees in mastering core software engineering concepts.",
      "• Conducted detailed code reviews, emphasizing industry best practices, clean code principles, and scalable solutions.",
      "• Simplified complex business logic and architectural decisions with practical, real-life examples, helping mentees understand how applications evolve over time.",
      "• Guided mentees through real-world problem-solving scenarios, ensuring they gained hands-on experience and clarity in decision-making.",
      "• Introduced a wide array of career paths within technology, advising on tools, frameworks, and skills essential for excelling in specific domains.",
      "• Supported mentees in identifying growth opportunities, setting achievable goals, and encouraging continuous learning."
    ],
    technologies: [
      "Mentoring", "Web Development", "Full Stack", "Software Engineering", "Code Review",
      "Knowledge Sharing", "Debugging and Troubleshooting"
    ]
  },
  {
    date: "May 2020 – Apr 2022",
    year: "2020-2022",
    company: "University of Toronto",
    role: "Assistant Instructor – Full Stack Web Development",
    responsibilities: [
      "• Taught and mentored individuals transitioning into tech careers, focusing on HTML, CSS, JavaScript, and frameworks such as React.js, Node.js, Express.js, and jQuery.",
      "• Guided students in building responsive and user-friendly designs, leveraging modern libraries and key NPM packages for streamlined development.",
      "• Provided hands-on support by resolving programming challenges, offering relatable real-life examples, and fostering a problem-solving mindset.",
      "• Conducted engaging tutorials, interactive labs, and review sessions to enhance understanding and build practical skills.",
      "• Evaluated weekly assignments, delivering constructive feedback to promote growth and adherence to industry best practices.",
      "• Actively participated in course meetings, collaborating with instructional teams to implement and refine curriculum tailored to student needs.",
      "• Inspired students to embrace continuous learning and adapt to evolving technologies, empowering them to confidently transition into tech careers."
    ],
    technologies: [
      "HTML", "CSS", "JavaScript", "jQuery", "AJAX", "React.js", "Node.js",
      "Express.js", "MongoDB", "REST APIs", "Responsive Design", "npm"
    ]
  },
  {
    date: "May 2021 – Sept 2021",
    year: "2021",
    company: "Myplanet",
    role: "Software Developer",
    project: "Data Consolidation",
    responsibilities: [
      "• Enabled Think Unlimited's team to generate reporting capabilities for internal and external users.",
      "• Designed and implemented an ETL architecture consolidating data from multiple marketing APIs, made available via a GraphQL API layer for data visualization.",
      "• Built AWS-backed infrastructure for centralized and consolidated data ingestion from diverse sources.",
      "• Contributed to Agile processes including sprint planning, daily standups, testing, retrospectives, and reviews."
    ],
    technologies: [
      "Python", "Flask", "Graphene", "GraphQL", "SQLite", "PostgreSQL",
      "AWS Lambda", "Terraform", "Asyncio", "GitHub", "Jira"
    ]
  },
  {
    date: "Jun 2020 – Apr 2021",
    year: "2020-2021",
    company: "Finneo",
    role: "Software Engineer",
    project: "Commercial Real Estate Application",
    responsibilities: [
      "• Maintained and optimized the architecture of a MERN-based Real Estate application, ensuring a seamless end-user experience and managing RESTful API endpoints.",
      "• Developed dynamic, interactive dashboards integrating user data and third-party real estate APIs (CHERRE, YARDI, MRI) for up-to-date US and Canada market data.",
      "• Designed and integrated an email system using SendGrid, increasing user engagement and retention on the platform.",
      "• Collaborated in an Agile environment to plan workflows, user journeys, and develop new features, ensuring timely delivery.",
      "• Implemented CI/CD pipelines on Bitbucket Cloud, reducing deployment times and streamlining the development process.",
      "• Built interactive data visualizations using Chart.js and Canvas.js, enhancing user experience with real-time market insights.",
      "• Generated reports and exported data to PDF format with jsPDF, providing comprehensive views of real estate trends.",
      "• Leveraged Jira and Asana for project management, tracking progress through sprints and ensuring smooth development cycles."
    ],
    technologies: [
      "React.js", "Node.js", "Express.js", "MongoDB", "PostgreSQL", "Ant Design",
      "Redux", "Redux Sagas", "Feathers.js", "AWS", "Bitbucket", "DigitalOcean",
      "SendGrid", "Google Maps", "Chart.js", "Canvas.js", "jsPDF", "Jira", "Asana"
    ]
  },
  {
    date: "Jan 2017 – Mar 2019",
    year: "2017-2019",
    company: "Bank Muscat",
    role: "Senior Oracle Database Administrator",
    responsibilities: [
      "• Managed the daily operations of 3 production and 9 non-production databases, ensuring high availability and performance for critical banking applications.",
      "• Ensured compliance with banking regulations and maintained database integrity across applications, network systems, and external payment gateways.",
      "• Implemented and maintained banking standards, including the integration of Value Added Tax (VAT) for financial transactions.",
      "• Deployed and configured the PRTG Network Monitoring tool to proactively monitor system health and identify potential issues before they impacted operations.",
      "• Administered Oracle Databases (RAC), optimizing performance and security through regular maintenance, patching, and system upgrades.",
      "• Utilized Oracle Enterprise Manager to streamline database management, monitoring, and troubleshooting.",
      "• Collaborated with cross-functional teams to address issues related to database performance, networking, and application integration.",
      "• Provided support in disaster recovery, ensuring data availability and integrity through regular backups and failover mechanisms."
    ],
    technologies: [
      "Oracle Databases", "Oracle RAC", "Oracle Enterprise Manager", "PRTG",
      "HP-UX", "Windows Server 2012"
    ]
  },
  {
    date: "Jul 2014 – Jan 2017",
    year: "2014-2017",
    company: "Progress Ways Information Technology",
    role: "Oracle Consultant",
    projects: [
      {
        name: "Implementation of Audit Vault and Database Firewall (AVDF)",
        details: [
          "• Integrated AVDF with Oracle EBS to log application-level changes, ensuring compliance with internal and regulatory standards.",
          "• Enabled real-time auditing for critical applications, improving visibility into database operations and reducing security risks."
        ],
        technologies: "Oracle 11g RAC, AVDF 12.1, EBS R12.1.2, Enterprise Manager"
      },
      {
        name: "Implementation of Oracle Database Vault (DBV)",
        details: [
          "• Implemented Oracle DBV to enforce data security policies across production, development, and testing environments.",
          "• Developed and mapped the Separation of Duty Matrix for various roles to restrict unauthorized access and improve compliance."
        ],
        technologies: "Oracle 11gR2 RAC, DBV 11gR2, Solaris 10, Enterprise Manager 12c, EBS 12.1.2"
      },
      {
        name: "Oracle E-Business Suite Upgrade (12.1 → 12.2)",
        details: [
          "• Managed the upgrade from EBS 12.1 to 12.2, reducing production downtime to 45 hours and ensuring minimal user disruption.",
          "• Applied security patches and validated their integration across the entire EBS environment to mitigate vulnerabilities."
        ],
        technologies: "UNIX, Solaris 10, Oracle 11g RAC, Fusion Middleware, WebLogic Server 10.3.6, EBS 12.1/12.2"
      },
      {
        name: "Enterprise Infrastructure Upgrade",
        details: [
          "• Upgraded legacy databases (Oracle 9i/10g) to Oracle 11gR2/12c, enabling enhanced performance and scalability.",
          "• Implemented High Availability (RAC) configuration for critical databases, reducing downtime and improving system resilience.",
          "• Configured Physical Standby DR sites for continuous data protection and business continuity.",
          "• Led physical migration of servers from old data centers to new facilities, ensuring integrity and security of all enterprise data."
        ],
        technologies: "Linux, HP-UX 11.31, Oracle 11g RAC, Oracle R12.1.2, Enterprise Manager, Solaris"
      }
    ],
    technologies: [
      "Oracle 11g/12c RAC", "Oracle EBS R12", "AVDF 12.1", "Oracle DBV",
      "Oracle Enterprise Manager 12c", "Fusion Middleware", "WebLogic Server 10.3.6",
      "Solaris 10", "HP-UX 11.31", "Linux", "UNIX"
    ]
  }
];

export default workExperience;
